const BASE_URL = 'https://api.dev.auxo.dk/public/content';

export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${BASE_URL}/${collectionName}`);
    if (!response.ok) throw new Error(`Failed to fetch ${collectionName}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return [];
  }
}

export async function fetchEntryById(collectionName, entryId) {
  try {
    const response = await fetch(`${BASE_URL}/${collectionName}/${entryId}`);
    if (!response.ok) throw new Error(`Failed to fetch entry ${entryId}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
}
